import React from 'react';
// import useTheme from '../../hooks/useTheme';

import { useNavigate } from 'react-router-dom';
import { setCookie } from '../../utils/cookieHelper';
 import { getUserPermission } from '../../actions/userActions';
import { USER_LOGIN_SUCCESS } from '../../constants/userConstants';
import { useDispatch } from 'react-redux';
	import { encryptData,decryptData } from '../../utils/crypto';

/**
 * Handles the otp process by submitting the otp  verificaton.
 * If otp is correct, redirects the user to the dashboard page.
 * @function
 * @return {void}
 */
function RoutePage() {
  // const {color} = useTheme();
 const navigate =  useNavigate()
 const dispatch = useDispatch();

  const reqObj = window.location.pathname.split('/')?.pop()
  if(window.location.pathname.includes('route')){
      let res = decodeURIComponent(reqObj);
  res = atob(res);
  const responseReq = JSON.parse(res);
  const cookies = responseReq['cookie'];
  const local = responseReq['local'];
  const session = responseReq['session'];
  let cookiesObj;

    if (typeof cookies === 'string') {
      // Parse cookie string like "key=value; key2=value2"
      cookiesObj = Object.fromEntries(
          cookies.split('; ').map(cookie => {
              const [key, value] = cookie.split('=');
              return [key, value];
          })
      );
  } else if (typeof cookies === 'object' && cookies !== null) {
      // Already an object
      cookiesObj = cookies;
  } else {
      cookiesObj = {}; // fallback if null or undefined
  }

  // Set each cookie using Object.entries
  Object.entries(cookiesObj).forEach(([key, value]) => {
      setCookie({ name: key, value: value });
      // If you want to use the cookieService, uncomment the line below
      // this.cookieService.set(key, this.encryptData(key, value), undefined, '/');
  })
    Object.entries(local).forEach(([key]) => {
      localStorage.setItem(key, local[key]);
    });

    if (cookiesObj.token) {
      const token = cookiesObj.token;
    
      // Get existing userInfo if it exists
      const existingUserInfo = decryptData(localStorage.getItem('userInfo'));

      let userInfoObj = {};
      if (existingUserInfo) {
          userInfoObj = JSON.parse(existingUserInfo);
      }
    
      // Set or update the authorizationToken
      userInfoObj.authorizationToken = token;
    
      // Save back to localStorage
      localStorage.setItem('userInfo', encryptData(JSON.stringify(userInfoObj)));
    }


    Object.entries(session).forEach(([key]) => {
      sessionStorage.setItem(key,session[key]);
    });
    // const userInfo = getCookie('userInfo')
    const userInfo = JSON.parse(decryptData(localStorage.getItem('userInfo')));
    console.log(userInfo)
    getUserPermission(userInfo,true).then(function(data){
        navigate('/dashboard')
        console.log(data)
    })
    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: userInfo,
    });

   
  }

	return (
  <>
           
		</>
	);
}
export default React.memo(RoutePage);
